module.exports = __webpack_public_path__ + "img/12.4b805c92.png";